import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";


export const addPracticeInfoDetailsAPI = createAsyncThunk(
    "addPracticeInfoDetailsAPI",
    async (data) => {
        const result = await FetchRequestHandler("post", `${baseUrl}api/practices`, data);
        return result;
    }
)